import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useApiService } from '@/hooks/useApiService';
import { VersionAccountStatus } from '@/types';

function RedirectToLesson() {
    const navigate = useNavigate();
    const { getVersionAccountStatus } = useApiService();
    const { formationId, versionId } = useParams<{ formationId: string; versionId: string }>();
    const findLastTrueKey = (statuses: VersionAccountStatus['lesson_statuses']) => {
        const entries = Object.entries(statuses);

        for (let i = entries.length - 1; i >= 0; i--) {
            const [key, value] = entries[i];
            if (value === true) {
                return key;
            }
        }

        return null;
    };

    useEffect(() => {
        const fetchData = async () => {
            if (formationId && versionId) {
                const accountStatus: VersionAccountStatus = await getVersionAccountStatus(formationId, versionId);

                const lastTrueKey = findLastTrueKey(accountStatus.lesson_statuses);

                if (lastTrueKey) {
                    navigate(`/formation/${formationId}/version/${versionId}/lesson/${lastTrueKey}`);
                } else {
                    navigate(`/formation/${formationId}/version/${versionId}/lesson/1`);
                }
            }
        };
        fetchData().catch(console.error);
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formationId, versionId, navigate]);

    return null;
}

export default RedirectToLesson;
